import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const starRating: ComponentTemplate = {
  id: "c8c30090-0b7b-4766-ab8c-8a11f2a23105",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Component/Star Rating",
  leftBarCategory: { main: "basic", subCategory: "core" },
  tags: ["reviews"],
  preview: "component/star-rating.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "starRating",
    props: {
      _starCount: 5,
      _size: "16px",
      _starColor: "#000000",
      _totalStars: 5,
      style: {
        display: "flex",
        flexDirection: "row",
      },
    },
  },
};
